module.exports = __webpack_public_path__ + "img/card.8e8f2a6d.png";